import { Typography } from "@mui/material";
import { TooltipProps } from "recharts";

// Definimos el tipo del payload para asegurarnos de que estamos accediendo a los datos correctos.
type CustomPayload = {
  name: string;
  value: number;
};

export const PieChartTooltip = ({ active, payload }: TooltipProps<number, string>) => {
  if (active && payload && payload.length > 0) {
    const { name, value } = payload[0] as CustomPayload;

    return (
      <div style={{ background: "#fff", padding: 10, border: "1px solid #ccc" }}>
        <Typography variant="subtitle2" sx={{ fontWeight: "bold", fontSize: "16px" }}>
          {name}
        </Typography>
        <Typography variant="body2" sx={{ fontSize: "14px" }}>
          <span style={{ fontWeight: "bold" }}>Total: </span>{value}
        </Typography>
      </div>
    );
  }

  return null;
};
